import { graphql } from '@/gql';
import type { UpdatePartnerCallerRideAllowanceTierMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updatePartnerCallerRideAllowanceTier = async ({
  partnerCode,
  phoneNumber,
  data,
}: UpdatePartnerCallerRideAllowanceTierMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      partnerCode,
      phoneNumber,
      data,
    },
    mutation: graphql(`
      mutation UpdatePartnerCallerRideAllowanceTier(
        $partnerCode: String!
        $phoneNumber: String!
        $data: UpdatePartnerCallerRideAllowanceTierInput!
      ) {
        updatePartnerCallerRideAllowanceTier(partnerCode: $partnerCode, phoneNumber: $phoneNumber, data: $data) {
          callerId
          partnerId
          defaultRideAllowanceTier
          defaultRideAllowanceAmount
          notes
        }
      }
    `),
  });

  return response.data?.updatePartnerCallerRideAllowanceTier;
};
